import noop from 'lodash/noop';
import * as React from 'react';

import styles from './index.css';
import { Map } from './map';
import { EMapTypes } from '../../../constants/map';
import { IRoadInfoSchema, IStationInfoSchema } from '../../../types';
import { getDistanceHighway, getDistanceRailway } from '../../../utils/helpers';
import { MapPreview } from '../../MapPreview';
import { HighwayIcon, RailwayIcon } from '../../common/icons';
import { Card } from '../card';
import { PopupMobile } from '../popup_mobile';
import { PopupHeader } from '../popup_mobile/popup_header';

export interface IMapLayoutStateProps {
  coordinates: {
    lat: number;
    lng: number;
  };
  fullAddress: string;
  regionId?: number;
  roadInfo?: IRoadInfoSchema;
  stationInfo?: IStationInfoSchema;
  yandexApiKeySatellite?: string | null;
  mapType: EMapTypes;
  isFat?: boolean;
  mapPreviewUrl: string;
}

export interface IMapLayoutDispatchProps {
  setMapType(mapType: EMapTypes): void;
}

type TMapLayoutProps = IMapLayoutStateProps & IMapLayoutDispatchProps;

export class MapLayout extends React.Component<TMapLayoutProps> {
  public render() {
    const { coordinates, fullAddress, mapType, setMapType, yandexApiKeySatellite, isFat, mapPreviewUrl } = this.props;

    return (
      <Card joinTop={!isFat}>
        <div className={styles['title']}>{fullAddress}</div>
        {this.getRoadInfo()}
        {this.getStationInfo()}
        <PopupMobile
          popupContent={({ onClose }) => (
            <div className={styles['popup_container']}>
              <PopupHeader title="Расположение" onClose={onClose} />
              <Map
                coordinates={coordinates}
                infrastructureList={[]}
                searchInfrastructures={noop}
                setMapType={setMapType}
                yandexApiKeySatellite={yandexApiKeySatellite}
                mapType={mapType}
              />
            </div>
          )}
        >
          <MapPreview link={mapPreviewUrl} className={styles['map_preview']}>
            <div className={styles['marker']} />
          </MapPreview>
        </PopupMobile>
      </Card>
    );
  }

  private getRoadInfo = () => {
    const { regionId, roadInfo } = this.props;

    if (!roadInfo) {
      return null;
    }

    return this.getInfoBlock(roadInfo.name, getDistanceHighway(roadInfo, regionId, 'от'), HighwayIcon);
  };

  private getStationInfo = () => {
    const { stationInfo } = this.props;

    if (!stationInfo) {
      return null;
    }

    return this.getInfoBlock(stationInfo.stationName, getDistanceRailway(stationInfo), RailwayIcon);
  };

  private getInfoBlock = (name: string = '', distance: string, icon: () => JSX.Element) => {
    return (
      <div className={styles['info']}>
        <span className={styles['icon']}>{icon()}</span>
        {name}
        {distance && <>, {distance}</>}
      </div>
    );
  };
}
